import { filter, map } from "lodash";

export const startsWithVowel = str => {
  const vowels = "aeiouAEIOU";
  return vowels.indexOf(str[0]) !== -1;
};

const lineSeparatorRegEx = /(\r\n|[\n\v\f\r\x85\u2028\u2029])/;

export const splitLines = str => {
  return str
    ? filter(
      map(str.split(lineSeparatorRegEx), s => s.trim()),
      s => s
    )
    : [];
};

export const standardizeLines = str => splitLines(str).join("\n");
